/* eslint-disable */
export class GFFieldAfspraakplanner {
  constructor() {
    this.$selectDate = $('.gfield--type-Afspraakplanner .selected-date');

    $(document).on('click', '.gfield--type-Afspraakplanner .date-option', e => this.selectOption(e));
    $(document).on('change', '.Afspraakplanner_tijd .gfield-choice-input', e => this.selectRadioOption(e));

    this.restoreSelection();
  }

  selectOption(e) {
    const $button = $(e.currentTarget);
    const selectedDate = $button.data('date');
    $('.gfield--type-Afspraakplanner .date-option').removeClass('selected');
    $button.addClass('selected');
    $('.gfield--type-Afspraakplanner .selected-date').val(selectedDate).trigger('change');
  }

  selectRadioOption(e) {
    const $input = $(e.currentTarget);
    $('.Afspraakplanner_tijd .gchoice label').removeClass('selected');
    $input.next('label').addClass('selected');
  }

  restoreSelection() {
    const selectedValue = this.$selectDate.val();
    if (selectedValue) {
      $('.gfield--type-Afspraakplanner .date-option')
        .removeClass('selected')
        .filter(`[data-date="${selectedValue}"]`)
        .addClass('selected');
    }
  }
}
